import { AssignedEntity } from '@engine/lib/assigned_entity';

function handleAssignedEntitiesForMIDs() {
  var currencies = new AssignedEntity({
    message: '#currency_validation_messages',
    container: '#currencies',
    form: '#currencies_form'
  });
  currencies.listenForCreate().listenForDestroy();
  var card_brands = new AssignedEntity({
    message: '#card_brand_validation_messages',
    container: '#card_brands',
    form: '#card_brands_form'
  });
  card_brands.listenForCreate().listenForDestroy();
}

function handleAssignedEntitiesForAcquirers() {
  var acquirer_bins = new AssignedEntity({
    message: '#acquirer_bin_validation_messages',
    container: '#acquirer_bins',
    form: '#acquirer_bin_form'
  });
  acquirer_bins.listenForCreate().listenForDestroy();
}

function handleAssignedEntities() {
  handleAssignedEntitiesForMIDs();
  handleAssignedEntitiesForAcquirers();
}

export { handleAssignedEntities };